import i18n from '@/i18n';
import { getToken } from '@nxtpeople/nxt-vue-keycloak';
import { useNxtVueEcho } from '@nxtpeople/nxt-vue-echo';
import { UserInfo } from '../collections/api/user/user-info.interface';
import { Batch } from '../collections/general/batch/batch.interface';
import { EchoEvents } from '../collections/general/web-socket/echo-events.interface';
import store from '../store';

export interface EchoEventResponse {
   batch: Batch;
   connection: string;
   user: UserInfo;
   failedJobs: number;
   completionPercentage: number;
}

export function useWebSockets() {
   const { echo, registerEcho, unregisterEcho } = useNxtVueEcho();

   const userChannel = computed(() => store.state.webSocket?.userChannel);

   async function registerWebSockets(userInfo?: UserInfo) {
      if (!userInfo) return;

      await registerEcho({
         key: import.meta.env.VITE_APP_PUSHER_KEY,
         authEndpoint: import.meta.env.VITE_APP_PUSHER_AUTH_ENDPOINT,
         cluster: import.meta.env.VITE_APP_PUSHER_CLUSTER,
         getToken,
      });

      store.commit('webSocket/SET_USER_CHANNEL', echo.value?.private(`User.${userInfo.id}`));

      userChannel.value?.listen(EchoEvents.BatchJobStarted, (data: EchoEventResponse) => {
         store.commit('batch/SET_BATCH', data);
      });

      userChannel.value?.listen(EchoEvents.BatchJobUpdated, (data: EchoEventResponse) => {
         const INDEX_OF_NOTIFICATION = store.state.notifications.findIndex((notification) => notification.id === data.batch.id);

         store.commit('UPDATE_NOTIFICATION_BY_INDEX', {
            new_notification: { message: `${i18n.global.t('actions.saving')} ${data.completionPercentage}%` },
            index: INDEX_OF_NOTIFICATION,
         });

         store.commit('batch/SET_BATCH', data);
      });

      userChannel.value?.listen(EchoEvents.BatchJobDone, (data: EchoEventResponse) => {
         // store.dispatch('alert/getAlertCount');
         store.commit('removeNotification', { id: data.batch.id });
         store.commit('batch/REMOVE_BATCH', data);
      });
   }

   return { registerWebSockets, unregisterEcho, echo, userChannel };
}
